/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaRootMiniReference,
    MediaRootMiniReferenceFromJSON,
    MediaRootMiniReferenceFromJSONTyped,
    MediaRootMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubclipUpdate
 */
export interface SubclipUpdate {
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipUpdate
     */
    asset: AssetMiniReference;
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubclipUpdate
     */
    rendered?: AssetMiniReference;
    /**
     * 
     * @type {boolean}
     * @memberof SubclipUpdate
     */
    shared?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubclipUpdate
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SubclipUpdate
     */
    tIn: number;
    /**
     * 
     * @type {number}
     * @memberof SubclipUpdate
     */
    tOut: number;
    /**
     * 
     * @type {MediaRootMiniReference}
     * @memberof SubclipUpdate
     */
    root: MediaRootMiniReference;
}

export function SubclipUpdateFromJSON(json: any): SubclipUpdate {
    return SubclipUpdateFromJSONTyped(json, false);
}

export function SubclipUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubclipUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': AssetMiniReferenceFromJSON(json['asset']),
        'rendered': !exists(json, 'rendered') ? undefined : AssetMiniReferenceFromJSON(json['rendered']),
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tIn': json['t_in'],
        'tOut': json['t_out'],
        'root': MediaRootMiniReferenceFromJSON(json['root']),
    };
}

export function SubclipUpdateToJSON(value?: SubclipUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': AssetMiniReferenceToJSON(value.asset),
        'rendered': AssetMiniReferenceToJSON(value.rendered),
        'shared': value.shared,
        'name': value.name,
        't_in': value.tIn,
        't_out': value.tOut,
        'root': MediaRootMiniReferenceToJSON(value.root),
    };
}


